// extracted by mini-css-extract-plugin
export default {"dcsc-powered-by":"styles-module__dcsc-powered-by___dZR6q","label":"styles-module__label___m3M5P"};